module.exports = __webpack_public_path__ + "static/media/logo.6baa15b5.png";